export default __webpack_public_path__ + "static/media/ic_wfuse_40.d9aa04cb.svg";